module.exports = __webpack_public_path__ + "static/media/account-image4.3dff0cc7.png";